import React, { useState } from 'react';
import './VirtualCFO.css';

function StartupConsulting() {
  const [activeIndex, setActiveIndex] = useState(null);

  const offerings = [
    {
      title: 'Business Model Advisory',
      content: [
        'Idea validation and MVP planning',
        'Go-to-market strategy support',
        'Competitive benchmarking',
        'Revenue model optimization',
        'Business plan development'
      ]
    },
    {
      title: 'Entity Formation & Legal Setup',
      content: [
        'Choosing right entity structure (Pvt Ltd, LLP, OPC, etc.)',
        'Company incorporation support',
        'PAN, TAN, GST, and MSME registrations',
        'Startup India registration assistance',
        'ESOP design and shareholder agreements'
      ]
    },
    {
      title: 'Investor & Pitch Readiness',
      content: [
        'Financial projections and valuation models',
        'Investor pitch deck creation',
        'Due diligence preparation',
        'Cap table planning and funding strategies'
      ]
    },
    {
      title: 'Compliance & Registrations',
      content: [
        'ROC compliance support',
        'Startup India recognition guidance',
        'Trademark, copyright, and IP filing assistance',
        'Advisory on regulatory filings and licenses'
      ]
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/startup_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>Startup Consulting Services</h1>
          <p>From ideation to execution, guiding startups to build solid foundations for growth</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Your Startup Journey, Backed by Strategy and Structure.</h2>
          <p>We help founders validate their business models, develop execution roadmaps, and address compliance from day one.</p>
          <p>Our startup consulting services cover entity setup, financial structuring, funding strategy, and regulatory registrations.</p>
          <p>We act as your strategic partner, simplifying company formation, tax registrations, investment pitch readiness, and legal compliance.</p>
          <p>Leverage our startup experience to get the operational edge and scalability your business deserves from day one.</p>
        </div>
      </section>

      {/* Accordion Section */}
      <section className="accordion-section">
        <h2>Our Offerings</h2>
        <div className="accordion-container">
          {offerings.map((item, index) => (
            <div key={index} className={`accordion-item ${activeIndex === index ? 'active' : ''}`}>
              <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                <span>{activeIndex === index ? '−' : '+'}</span> {item.title}
              </div>
              {activeIndex === index && (
                <div className="accordion-body">
                  <ul>
                    {item.content.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default StartupConsulting;


